module.exports = __webpack_public_path__ + "img/centrifuge-B-light.85925db2.png";